import React from 'react';
import './FinalFooter.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { openWhatsAppWithMessage, WHATSAPP_PHONE } from '../utils/contact';

const footerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

const FinalFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      className="footer-wrapper"
      variants={footerVariants}
      initial="hidden"
      animate="visible"
    >
      {/* CTA Section */}
      <div className="cta-banner">
        <div className="cta-overlay"></div>
        <div className="cta-content">
          <h2 className="cta-title">Your dream <br /> project awaits</h2>
          <p className="cta-subtitle">
            Whether you're exploring our services or envisioning something custom, 
            we're here to bring your vision to life.
          </p>
        </div>
      </div>

      {/* Main Footer Links */}
      <div className="footer-main">
        <div className="footer-brand">
          <div className="logo-section">
            <div className="logo-shape"></div>
            <span className="logo-text">MTPRO</span>
          </div>
          <p className="brand-tagline">
            We are creators of transformative spaces that inspire, innovate, and endure.
          </p>
        </div>

        <div className="footer-links-grid">
          <div className="link-column">
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/about#whyChooseUs">Why Choose Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about#clients">Partners</Link></li>
            </ul>
          </div>
          <div className="link-column">
            <ul>
              <li>Support Center</li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-contact">
          <h3 className="contact-phone">+{WHATSAPP_PHONE}</h3>
          <a href="mailto:info@mtproeg.com" className="contact-email">info@mtproeg.com</a>
          <div className="social-links">
            <span>Facebook</span>
            <span>Instagram</span>
            <span>YouTube</span>
            <span>LinkedIn</span>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="footer-bottom">
        <p>© {currentYear} <strong>MTPRO</strong>. All Rights Reserved.</p>
        <p className="footer-built-by">
          Website crafted by{' '}
          <a
            href="https://irouteweb.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            IrouteWeb
          </a>
        </p>
      </div>
    </motion.footer>
  );
};

export default FinalFooter;
